import React, { useState } from 'react'

const ChoiceServiceUsers = ({ valuesService, _deleteState, setPrestation }) => {
    return (
        <div className='mt-3'> 
            <div className='h5 mt-1'>Prestation sélectionnée</div>
            <div className='row pt-3 shadow'>
                <div className='col text-start'>
                    <div>
                        {valuesService.nameService} - {valuesService.durationService}min - {valuesService.priceService}€
                    </div>
                    <div className='row my-3'>
                    <>
                        {!valuesService.hours && 
                        <div className='col-9 text-start'>
                            <button 
                                type="button" 
                                className="btn btn-outline-dark rounded-pill" 
                                data-bs-toggle="modal"
                                data-bs-target="#choiceStaffModal"
                            >{valuesService.surnameStaff ? 
                                valuesService.surnameStaff : 'Choisir avec qui'}<i className="bi bi-chevron-compact-down ms-3"></i></button>
                        </div>
                        }
                        <div 
                            className={valuesService.hours ? 'col text-end' : 'col-3 text-end'} 
                            onClick={() => [setPrestation(false), _deleteState()]}
                            style={{cursor:'pointer'}}
                        >
                            <u>supprimer</u>
                        </div>
                    </>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ChoiceServiceUsers




